module.exports = __webpack_public_path__ + "img/活动中心.4ed64bae.png";